<div class="wrap">
    <div class="wrap-title">
        <img src="/assets/images/settings.svg" />
        <div class="text-title">
            <p class="title" translate>questionnaireSettings.title</p>
            <p class="description" translate>questionnaireSettings.description</p>
        </div>
    </div>

    <div class="wrap-settings">
        <div *ngIf="approvalRequiredEnabled" class="settings">
            <div class="settings-in">
                <div class="text">
                    <p class="text-title" translate>definitions.isApprovalRequired</p>
                    <p class="text-description" translate>questionnaireSettings.approvalRoles</p>
                </div>
                <que-toggle [toggleState]="isApprovalRequired.value"
                    (toggleEvent)="changeIsApprovalRequired($event)"></que-toggle>
            </div>
            <div *ngIf="isApprovalRequired.value" class="warp-input-select" >
                <div class="selected-roles" *ngIf="selectedRoles.length || selectedGroups.length">
                    <div class="selected-role" *ngFor="let item of selectedRoles; let i = index">
                        <div class="selected-role-info">
                            <span class="selected-role-number">{{ i + 1 }}.</span>
                            <p class="selected-role-text">
                                {{ ('questionnaireSettings.' + item.name) | translate }}
                            </p>
                        </div>

                        <button type="button" class="remove-role" (click)="removeApprover(item, $event)">
                            <img src="/assets/images/close.svg" alt="remove" />
                        </button>
                    </div>
                    <div class="selected-role" *ngFor="let item of selectedGroups; let i = index">
                        <div class="selected-role-info">
                            <span class="selected-role-number">{{ selectedRoles.length + i + 1 }}.</span>
                            <p class="selected-role-text">{{ item.name }}</p>
                        </div>

                        <button type="button" class="remove-role" (click)="removeGroup(item, $event)">
                            <img src="/assets/images/close.svg" alt="remove" />
                        </button>
                    </div>
                </div>

                <div (click)="isOpenAddRole = true" class="input-select" #adminsOrigin="cdkOverlayOrigin" cdkOverlayOrigin>
                    <img src="/assets/images/steps/add-step.svg">
                    <p class="select" translate>questionnaireSettings.addRole</p>
                </div>

                <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="adminsOrigin"
                    [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="isOpenAddRole = false"
                    [cdkConnectedOverlayOpen]="isOpenAddRole" cdkConnectedOverlayBackdropClass="backdrop-selection"
                    [cdkConnectedOverlayPositions]="positonArea">
                    <ng-container>
                        <div class="overlay-warp">
                            <div class="itemx" *ngFor="let item of rolesList">
                                <div [ngSwitch]="item.value">
                                    <div class="item-list">
                                        <div class="choose" [ngClass]="{'selected': item.choosed}"
                                            (click)="selectApprover(item)">
                                            <div class="inner-selected">
                                                <img src="/assets/images/auto-fill/vi.svg">
                                            </div>
                                        </div>
                                        <div *ngSwitchCase="eAprroverManager.FirstManager">
                                            <p translate>questionnaireSettings.firstManager</p>
                                        </div>
                                        <div *ngSwitchCase="eAprroverManager.SecondManager">
                                            <p translate>questionnaireSettings.secondManager</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="itemx" *ngFor="let item of groupsList">
                                <div class="item-list">
                                    <div class="choose" [ngClass]="{'selected': item.choosed}"
                                        (click)="selectGroup(item)">
                                        <div class="inner-selected">
                                            <img src="/assets/images/auto-fill/vi.svg">
                                        </div>
                                    </div>
                                    <div>
                                        <p>{{ item.name }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-template>
            </div>
        </div>
        <div class="settings">
            <div class="settings-in">
                <div class="text">
                    <p class="text-title" translate>definitions.isUnauthorized</p>
                    <p class="text-description" translate>questionnaireSettings.approvalRoles</p>
                </div>
                <que-toggle [toggleState]="isUnauthorized.value"
                    (toggleEvent)="changeIsUnauthorized($event)"></que-toggle>
            </div>
        </div>
        <div class="settings">
            <div class="settings-in">
                <div class="text">
                    <p class="text-title" translate>definitions.isNotificationEnabled</p>
                    <p class="text-description" translate>questionnaireSettings.notificationEmailDescription</p>
                </div>
                <que-toggle [toggleState]="isNotificationEnabled.value"
                    (toggleEvent)="changeIsNotificationEnabled($event)"></que-toggle>
            </div>
            <div *ngIf="isNotificationEnabled.value" class="warp-input-select">
                <input type="email" class="notification-email-input" [formControl]="notificationEmail"
                    [placeholder]="'questionnaireSettings.notificationEmailPlaceholder' | translate" />
                <p *ngIf="notificationEmail.invalid && notificationEmail.value" class="error-text" translate>
                    questionnaireSettings.notificationEmailInvalid
                </p>
            </div>
        </div>
        <div *ngIf="apiExposureEnabled" class="settings">
            <div class="settings-in">
                <div class="text">
                    <p class="text-title" translate>questionnaireSettings.entityLinkUpdate</p>
                    <p class="text-description" translate>questionnaireSettings.mapping</p>
                </div>

                <que-toggle [toggleState]="isApiExposure.value"
                    (toggleEvent)="changeApiExposureEnabled($event)"></que-toggle>
            </div>
        </div>
    </div>

    <div class="btns">
        <button type="button" class="cancel pointer" (click)="close()">
            <p translate>btns.cancel</p>
        </button>
        <button type="button" class="save pointer" (click)="confirm()" [disabled]="isSaveDisabled">
            <p translate>btns.save</p>
        </button>
    </div>
</div>